import { QueryClient } from "@tanstack/react-query";

const shouldRetryQuery = (failureCount, error) => {
  if (failureCount >= 1) {
    return false;
  }

  return error?.status === undefined || error.status >= 500;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
      refetchOnWindowFocus: true,
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
});
